import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { gql } from 'graphql-tag';
import { getTodayForUser } from '~/modules/common/dates/today';
import { useMeContext } from '~/modules/me/useMeContext';

export const RESOURCE_USER_PROFILE_ROLES_QUERY = gql`
  query GetResourceUserProfileRoles(
    $filter: GetResourceUsersFilter
    $asOfDate: Date2
  ) {
    resourceUsers2(filter: $filter) {
      roleSchedulesAsOfDate(asOfDate: $asOfDate) {
        effectiveRoleSchedule {
          projectRoles {
            projectRole {
              uri
              name
            }
            isPrimary
          }
        }
      }
    }
  }
`;

const useResourceUserProfileRolesQuery = ({ userId, skip = false } = {}) => {
  const me = useMeContext();
  const asOfDate = getTodayForUser(me);

  const { loading, data } = useQuery(RESOURCE_USER_PROFILE_ROLES_QUERY, {
    variables: { filter: { userIds: [userId] }, asOfDate },
    skip: skip || !userId
  });

  const profileRoles = useMemo(() => {
    const user = data?.resourceUsers2?.[0];
    const projectRoles =
      user?.roleSchedulesAsOfDate?.effectiveRoleSchedule?.projectRoles ?? [];

    return projectRoles.map(pr => ({
      roleUri: pr.projectRole.uri,
      displayText: pr.projectRole.name,
      isDefault: pr.isPrimary
    }));
  }, [data]);

  return { loading, profileRoles };
};

export default useResourceUserProfileRolesQuery;
